module.exports = __webpack_public_path__ + "img/ico_marker.3b1f8f49.png";